<script setup lang="ts">
const localePath = useLocalePath();

const heroLinks = [
  { label: "11th Computer", to: "/11th/computer/" },
  { label: "Paper Pattern", to: "/11th/computer/paper-pattern/" },
  { label: "Pairing Scheme", to: "/11th/computer/pairing-scheme/" },
  { label: "Important Questions", to: "/11th/computer/important-questions/" },
];

const computerStartLinks = [
  { title: "Paper Pattern", to: "/11th/computer/paper-pattern/", description: "Paper ka structure samjhein." },
  { title: "Pairing Scheme", to: "/11th/computer/pairing-scheme/", description: "Dekhein kis chapter se kya aata hai." },
  { title: "Important Questions", to: "/11th/computer/important-questions/", description: "Sab se pehle kya prepare karna hai." },
  { title: "Guess Paper", to: "/11th/computer/guess-paper/", description: "Final expected questions aur shortcut prep." },
];

const computerPracticeLinks = [
  { title: "Top 100 MCQs", to: "/11th/computer/mcqs/top-100/", description: "Fast objective revision ke liye." },
  { title: "Chapter-wise MCQs", to: "/11th/computer/mcqs/", description: "Har chapter ke MCQs alag se practice karein." },
  { title: "Python Topic Practice", to: "/11th/computer/python/", description: "Variables, loops, functions aur programs se start karein." },
  { title: "Practice Mode", to: "/11th/computer/practice/", description: "Mixed MCQs, short aur long questions revision." },
];

const chapterLinks = [
  { label: "Ch 1 SDLC", to: "/11th/computer/sdlc/" },
  { label: "Ch 2 Python", to: "/11th/computer/python/" },
  { label: "Ch 3 Algorithms", to: "/11th/computer/algorithm/" },
  { label: "Ch 4 Data Structures", to: "/11th/computer/data-structures/" },
  { label: "Ch 5 Data Analytics", to: "/11th/computer/data-analytics/" },
  { label: "Ch 6 Emerging Tech", to: "/11th/computer/emerging-tech/" },
  { label: "Ch 7 Legal & Ethics", to: "/11th/computer/legal-ethics/" },
  { label: "Ch 8 Digital Literacy", to: "/11th/computer/digital-literacy/" },
  { label: "Ch 9 Entrepreneurship", to: "/11th/computer/entrepreneurship/" },
];

const englishLinks = [
  { title: "11th English Hub", to: "/11th/english/", description: "Poems, prose, play, grammar aur downloads." },
  { title: "English Grammar", to: "/11th/english/grammar/", description: "Core grammar preparation." },
  { title: "English Downloads", to: "/11th/english/downloads/", description: "PDFs aur support material." },
];

const faqs = [
  {
    question: "Ustaad par 11th class computer ka paper kaise prepare karein?",
    answer:
      "Sab se pehle paper pattern samjhein, phir pairing scheme dekhein, us ke baad important questions aur MCQs par move karein. Yeh best start route hai.",
  },
  {
    question: "11th class computer ke liye sab se important chapter kaun sa hai?",
    answer:
      "Chapter 2 Python sab se important chapter hai. Us ke baad Chapter 3 Algorithms aur Chapter 1 SDLC strong scoring route dete hain.",
  },
  {
    question: "Kya Ustaad par chapter-wise computer preparation milti hai?",
    answer:
      "Haan, Chapter 1 se Chapter 9 tak har chapter ka apna hub, MCQs, short questions, long questions aur exercise route diya gaya hai.",
  },
  {
    question: "Kya Ustaad par 11th English bhi milti hai?",
    answer:
      "Haan, 11th English ke liye bhi separate hub, grammar, prose, poems, play aur downloads pages available hain.",
  },
];

usePageSeo({
  title: "11th Class Computer Exam Prep 2026 + 11th English",
  description:
    "Ustaad par 11th class computer exam prep 2026 ke liye paper pattern, pairing scheme, important questions, guess paper, MCQs aur chapter-wise study flow milta hai. 11th English support bhi available hai.",
  keywords:
    "11th class computer exam prep, 11th class computer paper pattern, 11th class computer pairing scheme, 11th class computer important questions, 11th class english",
  faqs,
  breadcrumbs: [{ name: "Home", item: "/" }],
  schemaType: "CollectionPage",
  schemaProperties: {
    about: {
      "@type": "Thing",
      name: "11th Class Study Hub",
    },
    hasPart: [
      { "@type": "WebPage", name: "11th Computer", url: "https://ustaad.today/11th/computer/" },
      { "@type": "WebPage", name: "Paper Pattern", url: "https://ustaad.today/11th/computer/paper-pattern/" },
      { "@type": "WebPage", name: "Pairing Scheme", url: "https://ustaad.today/11th/computer/pairing-scheme/" },
      { "@type": "WebPage", name: "Important Questions", url: "https://ustaad.today/11th/computer/important-questions/" },
      { "@type": "WebPage", name: "MCQs Top 100", url: "https://ustaad.today/11th/computer/mcqs/top-100/" },
      { "@type": "WebPage", name: "11th English", url: "https://ustaad.today/11th/english/" },
    ],
  },
});

useHead({
  script: [
    {
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "Ustaad",
        url: "https://ustaad.today",
        description: "Exam-focused study platform for 11th Computer and 11th English.",
      }),
    },
  ],
});
</script>

<template>
  <main class="mx-auto max-w-7xl px-4 py-8 md:py-12">
    <section class="rounded-[32px] border border-slate-200 bg-[radial-gradient(circle_at_top_left,_rgba(14,165,233,0.18),_transparent_34%),linear-gradient(135deg,_#f8fdff_0%,_#ffffff_48%,_#fefce8_100%)] p-6 shadow-[0_24px_80px_-50px_rgba(14,165,233,0.5)] dark:border-slate-700 dark:bg-[radial-gradient(circle_at_top_left,_rgba(14,165,233,0.18),_transparent_34%),linear-gradient(135deg,_#020617_0%,_#0f172a_56%,_#111827_100%)] md:p-8">
      <p class="text-xs font-semibold uppercase tracking-[0.28em] text-sky-700 dark:text-sky-300">
        Exam Prep Hub
      </p>
      <h1 class="mt-3 max-w-4xl text-3xl font-black tracking-tight text-slate-900 dark:text-white md:text-5xl">
        11th Computer ke liye direct exam-prep system. 11th English support bhi sath.
      </h1>
      <p class="mt-4 max-w-3xl text-sm leading-7 text-slate-700 dark:text-slate-300 md:text-base">
        Ustaad par 11th class computer ka paper pattern, pairing scheme, important questions, guess paper, MCQs aur chapter-wise study flow aik jagah milta hai. Agar aapko seedha pata karna ho ke kya parhna hai aur kahan se start karna hai, yahan se start karein.
      </p>

      <div class="mt-6 rounded-[24px] border border-emerald-200 bg-emerald-50 p-5 dark:border-emerald-900/40 dark:bg-emerald-950/20">
        <p class="text-sm font-medium text-slate-700 dark:text-slate-300">Yahan se start karein:</p>
        <div class="mt-3 space-y-2 text-sm leading-7 text-slate-900 dark:text-slate-100">
          <p>- Paper Pattern samjhein</p>
          <p>- Pairing Scheme dekhein</p>
          <p>- Important Questions prepare karein</p>
          <p>- MCQs se practice karein</p>
        </div>
        <p class="mt-4 text-base font-semibold text-emerald-700">Chapter 2 Python, Chapter 3 Algorithms aur Chapter 1 SDLC se strong start milega.</p>
      </div>

      <div class="mt-6 flex flex-wrap gap-3">
        <NuxtLink
          v-for="link in heroLinks"
          :key="link.to"
          :to="localePath(link.to)"
          class="inline-flex items-center justify-center rounded-full bg-slate-950 px-5 py-3 text-sm font-semibold text-white transition hover:bg-sky-700"
        >
          {{ link.label }}
        </NuxtLink>
      </div>
    </section>

    <section class="mt-10 grid gap-6 xl:grid-cols-[1.1fr_0.9fr]">
      <article class="rounded-[28px] border border-slate-200 bg-white p-6 dark:border-slate-700 dark:bg-slate-900">
        <p class="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">11th Computer</p>
        <h2 class="mt-2 text-2xl font-bold text-slate-900 dark:text-white">Computer preparation</h2>
        <p class="mt-3 text-sm leading-7 text-slate-600 dark:text-slate-300">
          Agar aapko 11th Computer prepare karna hai to sab se pehle paper samjhein, phir chapter mapping dekhein, phir important questions aur practice par move karein.
        </p>
        <div class="mt-5 grid gap-4 md:grid-cols-2">
          <NuxtLink
            v-for="item in computerStartLinks"
            :key="item.to"
            :to="localePath(item.to)"
            class="rounded-[22px] border border-slate-200 bg-slate-50 p-5 transition hover:border-sky-300 hover:bg-white dark:border-slate-700 dark:bg-slate-950/40 dark:hover:border-sky-700"
          >
            <h3 class="text-lg font-semibold text-slate-900 dark:text-white">{{ item.title }}</h3>
            <p class="mt-2 text-sm leading-7 text-slate-600 dark:text-slate-300">{{ item.description }}</p>
          </NuxtLink>
        </div>
      </article>

      <article class="rounded-[28px] border border-slate-200 bg-slate-50 p-6 dark:border-slate-700 dark:bg-slate-900/60">
        <p class="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">What To Study First</p>
        <h2 class="mt-2 text-2xl font-bold text-slate-900 dark:text-white">Shortcut priority</h2>
        <div class="mt-5 space-y-3 text-sm leading-7 text-slate-700 dark:text-slate-300">
          <p><span class="font-semibold text-slate-900 dark:text-white">CRITICAL:</span> Python (Chapter 2)</p>
          <p><span class="font-semibold text-slate-900 dark:text-white">HIGH:</span> Algorithms (Chapter 3), SDLC (Chapter 1)</p>
          <p><span class="font-semibold text-slate-900 dark:text-white">MEDIUM:</span> Data Structures (Chapter 4)</p>
          <p><span class="font-semibold text-slate-900 dark:text-white">LOW:</span> Remaining chapters for selective prep or MCQs</p>
        </div>
        <NuxtLink
          :to="localePath('/11th/computer/')"
          class="mt-5 inline-flex text-sm font-semibold text-sky-700 underline decoration-sky-300 underline-offset-4 dark:text-sky-300"
        >
          Open 11th Computer ->
        </NuxtLink>
      </article>
    </section>

    <section class="mt-10 rounded-[28px] border border-slate-200 bg-white p-6 dark:border-slate-700 dark:bg-slate-900">
      <div class="flex flex-wrap items-end justify-between gap-3">
        <div>
          <p class="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">Practice</p>
          <h2 class="mt-2 text-2xl font-bold text-slate-900 dark:text-white">MCQs, Python practice aur revision</h2>
        </div>
        <NuxtLink
          :to="localePath('/11th/computer/mcqs/top-100/')"
          class="text-sm font-semibold text-sky-700 hover:text-sky-800 dark:text-sky-300 dark:hover:text-sky-200"
        >
          Start with Top 100 MCQs ->
        </NuxtLink>
      </div>
      <div class="mt-5 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        <NuxtLink
          v-for="item in computerPracticeLinks"
          :key="item.to"
          :to="localePath(item.to)"
          class="rounded-[22px] border border-slate-200 bg-slate-50 p-5 transition hover:border-sky-300 hover:bg-white dark:border-slate-700 dark:bg-slate-950/40 dark:hover:border-sky-700"
        >
          <h3 class="text-lg font-semibold text-slate-900 dark:text-white">{{ item.title }}</h3>
          <p class="mt-2 text-sm leading-7 text-slate-600 dark:text-slate-300">{{ item.description }}</p>
        </NuxtLink>
      </div>
    </section>

    <section class="mt-10 rounded-[28px] border border-slate-200 bg-white p-6 dark:border-slate-700 dark:bg-slate-900">
      <div>
        <p class="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">Chapter-wise Study</p>
        <h2 class="mt-2 text-2xl font-bold text-slate-900 dark:text-white">11th Computer chapters</h2>
      </div>
      <p class="mt-3 text-sm leading-7 text-slate-600 dark:text-slate-300">
        Agar aap direct chapter se prepare karna chahte hain to neeche se apna chapter choose karein.
      </p>
      <div class="mt-5 flex flex-wrap gap-3">
        <NuxtLink
          v-for="item in chapterLinks"
          :key="item.to"
          :to="localePath(item.to)"
          class="rounded-full border border-slate-200 bg-slate-50 px-4 py-2 text-sm font-medium text-slate-900 transition hover:border-sky-300 hover:bg-white dark:border-slate-700 dark:bg-slate-950/40 dark:text-white dark:hover:border-sky-700"
        >
          {{ item.label }}
        </NuxtLink>
      </div>
    </section>

    <section class="mt-10 grid gap-6 lg:grid-cols-[1.1fr_0.9fr]">
      <article class="rounded-[28px] border border-slate-200 bg-slate-50 p-6 dark:border-slate-700 dark:bg-slate-900/60">
        <p class="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">11th English</p>
        <h2 class="mt-2 text-2xl font-bold text-slate-900 dark:text-white">English support</h2>
        <p class="mt-3 text-sm leading-7 text-slate-600 dark:text-slate-300">
          11th English ke liye grammar, textbook aur download support bhi available hai.
        </p>
        <div class="mt-5 grid gap-4">
          <NuxtLink
            v-for="item in englishLinks"
            :key="item.to"
            :to="localePath(item.to)"
            class="rounded-[22px] border border-slate-200 bg-white p-5 transition hover:border-sky-300 hover:bg-sky-50 dark:border-slate-700 dark:bg-slate-950/40 dark:hover:border-sky-700"
          >
            <h3 class="text-lg font-semibold text-slate-900 dark:text-white">{{ item.title }}</h3>
            <p class="mt-2 text-sm leading-7 text-slate-600 dark:text-slate-300">{{ item.description }}</p>
          </NuxtLink>
        </div>
      </article>

      <article class="rounded-[28px] border border-slate-200 bg-white p-6 dark:border-slate-700 dark:bg-slate-900">
        <p class="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">How this helps</p>
        <h2 class="mt-2 text-2xl font-bold text-slate-900 dark:text-white">Aik jagah par poori direction</h2>
        <div class="mt-5 space-y-3 text-sm leading-7 text-slate-600 dark:text-slate-300">
          <p>- Paper pattern batata hai paper ka structure</p>
          <p>- Pairing scheme batati hai kis chapter se kya aata hai</p>
          <p>- Important questions shortlist dete hain</p>
          <p>- MCQs aur practice mode revision complete karte hain</p>
          <p>- Chapter hubs se targeted preparation hoti hai</p>
        </div>
      </article>
    </section>

    <section class="mt-10 rounded-[28px] border border-slate-200 bg-white p-6 dark:border-slate-700 dark:bg-slate-900">
      <div>
        <p class="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">FAQ</p>
        <h2 class="mt-2 text-2xl font-bold text-slate-900 dark:text-white">Homepage FAQs</h2>
      </div>
      <div class="mt-5 grid gap-4 lg:grid-cols-2">
        <article
          v-for="faq in faqs"
          :key="faq.question"
          class="rounded-[22px] border border-slate-200 bg-slate-50 p-5 dark:border-slate-700 dark:bg-slate-950/40"
        >
          <h3 class="text-lg font-semibold text-slate-900 dark:text-white">{{ faq.question }}</h3>
          <p class="mt-2 text-sm leading-7 text-slate-600 dark:text-slate-300">{{ faq.answer }}</p>
        </article>
      </div>
    </section>
  </main>
</template>
